import { Avatar } from "@material-ui/core";
import React from "react";
import ImageUpload from "./ImageUpload";
import "./Message.css";

const Message = ({ user, timestamp, message, assetUrl }) => {
  // console.log(assetUrl);
  return (
    <div className="message">
      <Avatar src={user.photo} />
      <div className="message__info">
        <h4>
          {user.displayName}
          <span className="message__timestamp">
            {new Date(timestamp?.toDate()).toUTCString()}
          </span>
        </h4>
        <p>{message}</p>
        {/*
         <ImageUpload assetUrl={assetUrl} /> 
       */}
        <img src={assetUrl} alt='dummmsssssssssss' />
      </div>
    </div>
  );
};

export default Message;
